// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_DashboardResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/dashboard.
 *
 * Aggregated counts by order status. Wire shape is an id-keyed
 * Record<string, int> map (status name -> count); legacy callers iterate
 * the keys directly so the map shape must be preserved (a list-of-rows
 * shape would break the frontend dashboard cards).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_DashboardResponseDados = Record<string, number>;

export type Orders_DashboardResponse = ApiResponse<Orders_DashboardResponseDados>;

registerResponseContract('Orders_DashboardResponse', {})
